import gql from 'graphql-tag'

export const QUERY_GET_ABSOLUTE_DISCOUNT_LOCKS = gql`
  query AbsoluteDiscountLocks(
    $type: AbsoluteDiscountLockType!
    $search: String
    $sort: [AbsoluteDiscountLockSortableField!]
    $sortDirection: [SortDirection!]
    $pageSize: Float
    $page: Float
  ) {
    absoluteDiscountLocks(type: $type, search: $search, sort: $sort, sortDirection: $sortDirection, pageSize: $pageSize, page: $page) {
      page
      records
      absolute_discount_locks {
        _id
        user {
          _id
          document_no
          name
        }
        unit {
          id_erp
          name
        }
        type
        absolute_discount_value
        locked_by
        locked_at
      }
    }
  }
`

export const MUTATION_RELEASE_ABSOLUTE_DISCOUNT_LOCK = gql`
  mutation ReleaseAbsoluteDiscountLock($_id: String, $document_no: String, $type: String) {
    releaseAbsoluteDiscountLock(_id: $_id, document_no: $document_no, type: $type)
  }
`

export const MUTATION_RELEASE_ABSOLUTE_DISCOUNT_AND_CONSUME_LOCK = gql`
  mutation ReleaseAbsoluteDiscountAndConsumeLock($_id: String, $document_no: String, $type: String) {
    releaseAbsoluteDiscountAndConsumeLock(_id: $_id, document_no: $document_no, type: $type)
  }
`
